module.exports = __webpack_public_path__ + "img/car_00029.358dfd18.jpg";